import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// Define styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    position: "relative",
  },
  header: {
    marginBottom: 10,
    textAlign: "center",
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 4,
  },
  shopInfo: {
    fontSize: 10,
    marginBottom: 2,
  },
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    marginVertical: 1,
    width: "100%",
  },
  thickDivider: {
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    marginVertical: 1,
    width: "100%",
  },
  reportTitle: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 2,
    marginBottom: 3,
  },
  table: {
    display: "table",
    width: "100%",
    marginVertical: 10,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "33.33%",
    padding: 5,
    textAlign: "center",
    fontSize: 12,
    fontWeight: "bold",
    borderWidth: 1,
    borderColor: "#000",
    backgroundColor: "#f1f1f1",
    color: "#000232",
  },
  tableCol: {
    width: "33.33%",
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    borderWidth: 1,
    borderColor: "#E7EBF4",
  },
  tableRowAlternate: {
    backgroundColor: "#F5F5F5",
  },
  grandTotalRow: {
    backgroundColor: "#E7EBF4",
    fontWeight: "bold",
  },
  footer: {
    position: "absolute",
    bottom: 15, // Adjust this value if needed to fit nicely at the bottom
    left: 0,
    right: 0,
    flexDirection: "row",
    justifyContent: "space-around",
    fontSize: 10,
  },
});

// PDF document component
const MinimumStockReportPDFDocument = ({ reports, grandTotalDebit, grandTotalCredit, openingBalance, closingBalance, user, startDate, endDate }) => (
  <Document>
    <Page style={styles.page} size="A4" orientation="landscape">

      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.title}>{user?.invoice_settings?.shop_name || "N/A"}</Text>
        <Text style={styles.shopInfo}>{user?.address}</Text>
        <Text style={styles.shopInfo}>Mobile: {user?.phone || "N/A"}</Text>
         {/* Horizontal Lines */}
         <View style={styles.thickDivider} />
        <View style={styles.divider} />
        <View style={styles.thickDivider} />
        <Text style={styles.reportTitle}>Minimum Stock Report</Text>
        <Text style={styles.shopInfo}>({startDate} to {endDate})</Text>
      </View>

      {/* Table */}
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <Text style={styles.tableColHeader}>Item Name</Text>
          <Text style={styles.tableColHeader}>Minimum Stock</Text>
          <Text style={styles.tableColHeader}>Closing Stock</Text>
        </View>
        {/* Table Body */}
        {reports.map((report, index) => (
          <View key={index} style={[styles.tableRow, index % 2 === 0 && styles.tableRowAlternate]}>
            <Text style={styles.tableCol}>{report?.particulars || "N/A"}</Text>
            <Text style={styles.tableCol}>{report?.debit || 0}</Text>
            <Text style={styles.tableCol}>{report?.closing_balance || 0}</Text>
          </View>
        ))}

        {/* Grand Total Row */}
        <View style={[styles.tableRow, styles.grandTotalRow]}>
          <Text style={styles.tableCol}>Grand Total</Text>
          <Text style={styles.tableCol}>{grandTotalDebit}</Text>
          <Text style={styles.tableCol}>{closingBalance}</Text>
        </View>
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <Text>Prepared by</Text>
        <Text>Checked/Recommended by</Text>
        <Text>Authorized by</Text>
      </View>
    </Page>
  </Document>
);

export default MinimumStockReportPDFDocument;
